module.exports = __webpack_public_path__ + "img/banner-partner.39aba4c3.jpg";